import { appTypeId } from '../../../../../models/application-types';

export class Controller {

    /** @ngInject */
    constructor($state, AddNewApplicationResource) {
        this.$state = $state;
        this.AddNewApplicationResource = AddNewApplicationResource;
    }

    $onInit() {
        this.applicationRequest = {
            applicationName: '',
            applicationRunningStatus: true,
            applicationType: appTypeId('enterprise-password-manager'),
            epmApplicationSettings: {
                publicServiceId: this.publicService.id,
                publicServiceLoginUrl: this.publicService.urlRequired ? '' : undefined,
                canUserSetPassword: true,
                canUserViewPassword: true,
            },
            mobileApplicationEnabled: false,
            ssoEnabled: true,
        };
    }

    canUserSetPasswordChanged() {
        if (this.applicationRequest.epmApplicationSettings.canUserSetPassword) {
            this.applicationRequest.epmApplicationSettings.canUserViewPassword = true;
        }
    }

    save() {
        this.isSaving = true;
        this.AddNewApplicationResource
            .createNonDomainApp(this.companyId, {applicationRequest: this.applicationRequest})
            .then(app => this.$state.go('company.manage-application', {appId: app.id}))
            .finally(() => this.isSaving = false);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/supported-epm-types/add/add-epm.controller.js